const calculatePercentage = (value: number, totalValue: number): string => {
  if (totalValue === 0) {
    return '0%';
  }
  return `${Math.round((value / totalValue) * 100)}%`;
};

export { calculatePercentage };
